//媒体文件上传

import request from '@/utils/request'

/* 图片
@params
data 
{
    "file": "data:image/jpeg;base64,/9j/4AAQSkZJRg"  //图片文件字节
}
@return 
{
    "code": "0",
	"method": "file.uploadImg",
	"o_ret": {
		"path": "https://tiqiuqu-api.gtdreamlife.com/image/2021/05/10/f4e9c4f6-9958-4041-bd12-5384634829ab.jpg" //图片路径
	},
	"message": "success"
}
*/
export function image(data) {
    return request({
        method: 'post',
        data: {
            method: "file.uploadImg",
            data: data
        }
    })
}


// WEBPACK FOOTER //
// ./src/api/media.js